module.exports = __webpack_public_path__ + "media/assets/images/partner-logo/hh-xplore-logo-f2a23ff7b250529a470e4247989d29af.svg";